import PropTypes from 'prop-types';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Collapse, Nav, NavItem, NavLink as BootstrapNavLink } from 'reactstrap';
import AppContext from '../../context/Context';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';
import { NavLink as RRNavLink } from 'react-router-dom';
import { useHistory } from 'react-router'



const NavbarVerticalMenu = ({ routes, location }) => {
  const [openedIndex, setOpenedIndex] = useState(null);
  const { setShowBurgerMenu } = useContext(AppContext);
  

  useEffect(() => {
    let openedDropdown = null;
    routes.forEach((route, index) => {
      if (location.pathname.indexOf(route.to) === 0) openedDropdown = index;
    });

    setOpenedIndex(openedDropdown);
    // eslint-disable-next-line
  }, []);

  const toggleOpened = (e, index) => {
    e.preventDefault();
    return setOpenedIndex(openedIndex === index ? null : index);
  };

  const getHr = name => {
    if (name === 'Widgets' || name === 'Documentation') {
      return (
        <div className="navbar-vertical-divider">
          <hr className="navbar-vertical-hr my-2" />
        </div>
      );
    }
  };
  //  const history = useHistory()
  //  const pathname = window.location.pathname

  // const reloadmultidialer = ()=>{
    
  //   if(pathname=="/multilinedialer"){
  //     console.log("inside")
  //     console.log({pathname})
  //     // window.location.reload();
  //   }
    
    
  // }
  
  
  return routes.map((route, index) => {
    const isExternal = route.to.startsWith('http://') || route.to.startsWith('https://');
    
    if (!route.children) {
      return (
        <Fragment key={index}>
          {getHr(route.name)}
          <NavItem>
            {isExternal ? (
              <a href={route.to} className="nav-link" target="_blank" rel="noopener noreferrer" onClick={() => setShowBurgerMenu(false)}>
                <NavbarVerticalMenuItem route={route} />
              </a>
            ) : (
              <NavLink to={route.to} className="nav-link" onClick={() => setShowBurgerMenu(false)}>
                <NavbarVerticalMenuItem route={route} />
              </NavLink>
            )}
          </NavItem>
          {/* <NavItem>
            <NavLink  className="nav-link" {...route}  onClick={() =>setShowBurgerMenu(false)  }>
              <NavbarVerticalMenuItem route={route}  />
            </NavLink>
          </NavItem> */}
        </Fragment>
      );
    }
    return (
      <Fragment key={index}>
        {getHr(route.name)}
        <NavItem>
          <BootstrapNavLink
            onClick={e => toggleOpened(e, index)}
            className="dropdown-indicator cursor-pointer"
            aria-expanded={openedIndex === index}
          >
            <NavbarVerticalMenuItem route={route} />
          </BootstrapNavLink>
          <Collapse isOpen={openedIndex === index}>
            <Nav>
              <NavbarVerticalMenu routes={route.children} location={location} />
            </Nav>
          </Collapse>
        </NavItem>
      </Fragment>
    );
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(NavbarVerticalMenu);
